var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugChargeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2363281,14H30v-2h-3.7636719c-1.1435547,0-2.171875,0.6357422-2.6835938,1.6582031l-1.3173828,2.6345215 C20.8522949,17.126709,20,18.6008301,20,20.2363281L20.0014648,22H17c-0.5517578,0-1-0.4482422-1-1v-6c0-1.6542969-1.3457031-3-3-3 h-3V4c0-1.1025391-0.8974609-2-2-2H4C2.8974609,2,2,2.8974609,2,4v24c0,1.1025391,0.8974609,2,2,2h4c1.1025391,0,2-0.8974609,2-2V14 h3c0.5517578,0,1,0.4482422,1,1v6c0,1.6542969,1.3457031,3,3,3h3.0031738l0.001709,4.2832031 C20.0048828,29.2460938,20.8828125,30,22.0029297,30h1.9980469C25.1220703,30,26,29.2460938,26,28.2832031V26h4v-2h-7.9951172 L22,22.0146484h4v-2h-3.9714355C22.0996094,19.1809082,22.5407715,18.4345703,23.2558594,18H30v-2h-5.3818359l0.7236328-1.4472656 C25.5117188,14.2119141,25.8544922,14,26.2363281,14z M8,4v6H4V4H8z M4,28V12h4v16H4z M22.0048828,26H24v2h-1.9951172V26z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugChargeSmall);
export default __webpack_public_path__ + "static/media/plug-charge--small.9b2b34f08dea50070ca91d9a8d9928f7.svg";
export { ForwardRef as ReactComponent };